import { React } from 'react';

const VerifyResetCodeForm = () => {
    return (
        <div>
            An email has been sent to the address requested. Please follow the instructions in the email to reset your password.
        </div>
    )
}

export default VerifyResetCodeForm